import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ResponseModelT } from 'src/app/shared/models/shared-models';
import { NmvModel } from 'src/app/shared/utils/shared-utils';
import { environment } from 'src/environments/environment';
import { IGalleryService } from '../../shared/models/data-page-presenter.models';

@Injectable({
  providedIn: 'root',
})
export class DataPagePresenterService {
  data: any = {
    idCliente: 1,
    title: 'Ofertas de Viajes, vuelos, paquetes turísticos en NMViajes',
    sections: [
      {
        id: 0,
        section: 'Ofertas',
        title: 'Ofertas únicas para ti',
        btn: 'Más ofertas',
        link: '#',
      },
      {
        id: 1,
        section: 'Paquetes',
        title: 'Paquetes turísticos',
        title2: '¡Elige ahora tu paquete nacional o internacional!',
        btn: 'Otros paquetes',
        link: '#',
      },
      {
        id: 2,
        section: 'Mapa',
        title: 'Nuestras mejores ofertas de Vuelo + Hotel saliendo de Lima',
      },
      {
        id: 3,
        section: 'Vuelos',
        title: '¡Corre y Vuela! con estas Súper ofertas de Vuelos saliendo desde Lima',
        btn: 'Más ofertas',
        link: '#',
      },
      {
        id: 4,
        section: 'Comprar',
        title: '¿Por qué comprar en NMVIAJES?',
        img: 'comprar.webp',
        card: [
          {
            id: 0,
            img: './assets/home/choose/best-offers.svg',
            title: 'Tenemos las mejores ofertas para tu viaje',
            description: '',
          },
          {
            id: 1,
            img: './assets/home/choose/safe-buy.svg',
            title: 'Comprar es fácil y seguro',
            description: '',
          },
          {
            id: 2,
            img: './assets/home/choose/experts.svg',
            title: 'Expertos en Viajes',
            description: '',
          },
        ],
      },
      {
        id: 5,
        section: 'mailing',
        title: '¡SUSCRÍBETE!',
        span: 'Se el primero en recibir nuestras novedades y promociones',
      },
      {
        id: 6,
        section: 'Footer',
        title1: 'Productos',
        list1: [
          {
            id: 0,
            text: 'Paquetes',
            link: 'https://nmviajes.paquetedinamico.com/ES/holidays/search',
            external: true,
          },
          {
            id: 1,
            text: 'Vuelos',
            link: '/vuelos',
          },
          {
            id: 2,
            text: 'Vuelos + Hotel',
            link: '#',
            tab: 2,
          },
          {
            id: 3,
            text: 'Hoteles',
            link: '#',
          },
          {
            id: 4,
            text: 'Actividades',
            link: '#',
          },
          {
            id: 5,
            text: 'Descubre',
            link: '#',
          },
          {
            id: 6,
            text: 'Blog: Mundo Viajero',
            link: '#',
          },
        ],
        title2: 'Conócenos',
        list2: [
          {
            id: 0,
            text: 'Quiénes somos',
            link: '/nuestra-empresa',
            target: '_self',
          },
          {
            id: 2,
            text: 'Trabaja con nosotros',
            link: 'https://expertiatravel.hiringroom.com/jobs',
            target: '_blank',
          },
          {
            id: 3,
            text: 'Responsabilidad Social Corporativa',
            link: 'responsabilidad-social',
            target: '_self',
          },
          {
            id: 4,
            text: 'Política de Protección de datos Personales',
            link: 'politicas',
            target: '_self',
          },
          {
            id: 5,
            text: 'Promociones',
            link: 'promociones',
            target: '_self',
          },
          {
            id: 6,
            text: 'Términos y condiciones',
            link: 'terminos-condiciones',
            target: '_self',
          },
        ],
        title3: 'Contáctanos',
        span: 'Agencias de Viajes en Lima Perú',
        address: 'Av. José Pardo 801, Miraflores - Lima 18, Perú',
        libro: 'Libro de reclamaciones',
        linkLibro: '/libro-reclamaciones',
      },
    ],
  };

  constructor(private httpClient: HttpClient) {}

  getDataGallery() {
    const nmvModel = new NmvModel();

    const options = {
      params: nmvModel.params.set('Parameter.Status', true),
    };
    const url = environment.urlNmviajes + '/Gallery';
    return this.httpClient
      .get<ResponseModelT<IGalleryService[]>>(url, options)
      .pipe(map((resp) => resp.Result));
  }
}
